import e from "../managers/braze-instance.js";
import { validateStandardString as P } from "../util/validation-utils.js";
export function setSdkAuthenticationSignature(t) {
  if (!e.X()) return !1;
  if ("" === t || !P(t, "set signature", "signature", !1)) return !1;
  const r = e.Sr();
  return !!r && (r.setSdkAuthenticationSignature(t), !0);
}
